<template>
  <div class="rounded border border-yellow-700 bg-yellow-200 text-yellow-700 p-4 mb-6">
    <h2 class="font-bold font-title flex items-center mb-2">
      <exclamation-triangle-icon class="h-6 w-6 mr-2" />
      {{
        $t(`shared-order-approval.step-${step}.deadline-approaching`, {
          deadline: deadline ? formatDateFromISO(deadline, "dd/LL/yyyy") : null,
        })
      }}
    </h2>
    <p class="text-sm">
      {{ $t(`shared-order-approval.step-${step}.deadline-approaching-explanation`) }}
    </p>
  </div>
</template>

<script setup>
import { DateTime } from "luxon"
import { formatDateFromISO } from "@/helpers/date-helpers"
import ExclamationTriangleIcon from "@/components/icons/ExclamationTriangleIcon.vue"

defineProps({
  deadline: {
    type: Object,
    validator(value) {
      return value instanceof DateTime
    },
    required: false,
    default: () => null,
  },
  step: {
    type: [String, Number],
    default: 1,
  },
})
</script>
